import { Toast } from 'vant'
//全局变量，函数
let baseUtl="https://test.pyjkd.com/test/";
function test (){
}
let loading       
function startLoading(str) {  
    loading = Toast.loading({
        duration:0,
        message: str?str:'加载中',
        forbidClick: true,
    })
}
function endLoading() {   
    loading.clear()
}
export default {
  baseUtl,
  test,
  startLoading,
  endLoading
}